export * from './lib/shared-cookie-consent-feature.module';
export * from './lib/config/index';
